export const SESSION_STATUS_CONSTANT = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRED: 'EXPIRED',
  IDLE_EXPIRED: 'IDLE_EXPIRED',
};
